import type { SessionUser } from "../../shared/auth/access";
import type { ContractDetail, ContractSummary } from "./contract-types";
import type { ContractEditorSeed } from "./contract-types";
export const statusLabels: Record<string, string> = {
    DRAFT: "Taslak",
    UNDER_REVIEW: "Onay bekliyor",
    PENDING_APPROVAL: "Onay bekliyor",
    ACTIVE: "Aktif",
    SUSPENDED: "Askıda",
    REJECTED: "Reddedildi",
    SUPERSEDED: "Önceki sürüm",
    EXPIRED: "Süresi doldu",
};
export const formatMoney = (value: string, currency: string) => new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency,
    maximumFractionDigits: 2,
}).format(Number(value));
export const formatDate = (value: string) => new Intl.DateTimeFormat("tr-TR", { day: "2-digit", month: "short", year: "numeric" }).format(new Date(value));
export function contractTotals(contracts: ContractSummary[], now: number) {
    return { active: contracts.filter(item => item.status === "ACTIVE").length, pending: contracts.filter(item => item.status === "UNDER_REVIEW").length, expiring: contracts.filter(item => { const days = (new Date(item.endDate).getTime() - now) / 86400000; return days >= 0 && days <= 60; }).length };
}
export function canDecideContract(user: SessionUser, detail: ContractDetail | null) {
    return detail?.versionStatus === "PENDING_APPROVAL" && ((user.role === "SATIN_ALMA_MUDURU" && !detail.approvals.some(item => item.approvalRole === "SATIN_ALMA_MUDURU")) || (user.role === "GENEL_MUDUR" && detail.approvals.some(item => item.approvalRole === "SATIN_ALMA_MUDURU" && item.decision === "APPROVED")));
}
export function contractEditorSeed(detail: ContractDetail): ContractEditorSeed {
    const items = detail.items.map<ContractEditorSeed["items"][number]>(item => { const category = item.category; if (category !== "Hammadde" && category !== "Ambalaj")
        throw new Error("Sözleşme kaleminin kategorisi doğrulanamadı."); return { ...item, category }; });
    return { ...detail, items };
}
